import * as React from 'react';

import { getAppraisal } from '../../../action/admin/Appraisal';
import { addBand } from '../../../action/admin/Band';
import Loder from '../../../component/common/Loader'
import Band from '../../../component/common/Band';
import { validateForm } from '../../../utils';
import CONSTANT from '../../../constant';

class AddBand extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            appraisalList: undefined,
            showLoader: false,
        }

    }

    componentDidMount() {
        this.getAllAppraisal();
    }

    public render() {
        const { appraisalList, showLoader } = this.state;
        return (
            <React.Fragment>
                <section>
                    <div className="col-lg-12 main-container">
                        <div className="fluid-container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="col-lg-12 mt-4">
                                        <div className="row">
                                            <div className="col-lg-6 pl-0">
                                                <h5 className="heading-h1">Add Define Band</h5>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        appraisalList &&
                                        <Band
                                            onSubmit={this.onSubmit}
                                            appraisalList={appraisalList}
                                        />

                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    showLoader && <Loder />
                }
            </React.Fragment>

        )
    }

    onSubmit = (model: any) => {
        this.setState({ showLoader: true });
        addBand(model)
            .then((res: any) => {
                alert('Record Update Successfully')
                this.setState({ showLoader: false });
                this.props.history.push(CONSTANT.url.bandList);
            })
            .catch((err: any) => {
                alert(err)

            })

    }

    private getAllAppraisal = () => {
        getAppraisal(undefined).then((response: any) => {
            if (response && response.result && response.result.length > 0)
                this.setState({
                    appraisalList: response.result,

                });
        });
    }

}

export default AddBand;